module.exports = __webpack_public_path__ + "static/media/utp-letterhead-color-restricted.1629911b.png";